import React from "react";
import { useDispatch } from "react-redux";
import { setIsFormFocused } from "../../../redux/actions";

interface Props {
    isFormInputFocused: boolean;
}

export default function InputFocusRenderer(props: Props) {
    const { isFormInputFocused } = props;
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!isFormInputFocused) {
            const questionToFocus = document.querySelector(".question--error");
            if (questionToFocus) {
                if (questionToFocus.scrollIntoView) {
                    questionToFocus.scrollIntoView(true);
                }
                const inputToFocus: HTMLElement = questionToFocus.querySelector(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                );
                if (inputToFocus) {
                    inputToFocus.focus();

                    dispatch(setIsFormFocused(true));
                }
            }
        }
    });

    return <></>;
}
